  import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
  import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

  export const vsObjectName = "machineProgressiveType";

  const url = "/api/machines/MachineProgressiveType";

  export const machineProgressiveTypeLookupConfig = simpleLookupConfig(
    vsLookupManagementServiceProviderName,
    {
      name: vsObjectName,
      nameSingular: "Progressive Type",
      url,
    }
  );
